import { render, staticRenderFns } from "./categoriesCards.vue?vue&type=template&id=371553b4&scoped=true&"
import script from "./categoriesCards.vue?vue&type=script&lang=js&"
export * from "./categoriesCards.vue?vue&type=script&lang=js&"
import style0 from "./categoriesCards.vue?vue&type=style&index=0&id=371553b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371553b4",
  null
  
)

export default component.exports